export const MESSENGERS = {
  WHATSAPP: {
    color: '#48C857',
  },
  INSTAGRAM: {
    color: '#C13584',
  },
  TELEGRAM: {
    color: '#24A2DF',
  },
  TELEGRAMCLIENT: {
    color: '#24A2DF',
  },
  BALE: {
    color: '#3B8E7A',
  },
  SMS: {
    color: '#8E50A5',
  },
  RUBIKA: {
    color: '#57DDDD',
  },
  EITAA: {
    color: '#F15A24',
  }
};
